import React from 'react';
import { cn } from '../utils/cn';

export const Skeleton = ({ className }) => (
  <div className={cn("animate-pulse bg-slate-800 rounded", className)} />
);

export const MapCardSkeleton = () => (
  <div className="bg-slate-900 border border-slate-800 rounded-xl p-5 space-y-4">
    <Skeleton className="h-6 w-24" />
    <Skeleton className="h-8 w-full" />
    <div className="flex justify-between py-4">
      <Skeleton className="h-12 w-12 rounded-full" />
      <Skeleton className="h-12 w-12 rounded-full" />
    </div>
    <Skeleton className="h-4 w-full rounded-full" />
  </div>
);